import React from 'react'
import FormatCurrency from '../elements/FormatCurrency'
import WrapIcon from '../elements/WrapIcon'
import DynamicColor from '../common/dynamic-color'

import { useTranslation } from 'react-i18next'
import { COLOR_NAME, PAYMENT_METHOD } from '../../constants'
import { getRealTime } from '../../utils/index'

import IconWaiting from '../../assets/icons/IconWaiting'
import IconDone from '../../assets/icons/IconDone'
import IconOrderTime from '../../assets/icons/IconOrderTime'
import IconHomeFill from '../../assets/icons/IconHomeFill'
import IconDeliverTime from '../../assets/icons/IconDeliverTime'
import IconCash from '../../assets/icons/IconCash'
import IconPaypalGrey from '../../assets/icons/IconPaypalGrey'
import IconDelivery from '../../assets/icons/IconDelivery'
import IconRestaurant from '../../assets/icons/IconRestaurant'

const OrderHisItem = ({ details = {}, index }) => {
    const { t } = useTranslation()

    const {
        totalMoney,
        tableNumber,
        createdDate,
        userAddressNumber,
        userStreet,
        userCity,
        state,
        timeDeliver,
        paymentMethod,
        kind,
    } = details

    const ICON_PAYMENT = {
        [PAYMENT_METHOD.CASH]: IconCash,
        [PAYMENT_METHOD.PAYPAL]: IconPaypalGrey,
    }

    const ICON_KIND = {
        PICKUP: IconRestaurant,
        QRCODE: IconRestaurant,
        DELIVER: IconDelivery,
    }

    return (
        <DynamicColor
            style={{
                color: COLOR_NAME.BODY_TEXT,
                backgroundColor: COLOR_NAME.BOX_BG,
            }}
            className="order-history__item p-2 pl-12 label-2"
        >
            <DynamicColor
                className="item-no"
                style={{
                    backgroundColor: COLOR_NAME.LAYOUT_BG,
                }}
            >
                {index ? (
                    index
                ) : (
                    <DynamicColor
                        style={{ fill: COLOR_NAME.BODY_BG, width: '28px' }}
                        tag={ICON_KIND[kind] || IconRestaurant}
                    />
                )}
            </DynamicColor>

            <DynamicColor
                style={{ borderColor: COLOR_NAME.BODY_LINE }}
                className="item-main m-2"
            >
                <div className="d-flex y-center">
                    <div>
                        {`${t('orderHistory.code')}: `}
                        <b className="ml-1">{tableNumber}</b>
                    </div>

                    <WrapIcon
                        className="ml-6"
                        size="24px"
                        icon={state === 1 ? IconDone : IconWaiting}
                    />
                </div>

                <div className="row">
                    <div className="col-12 mt-4 col-md-6 d-flex y-top">
                        <DynamicColor
                            style={{
                                fill: COLOR_NAME.BODY_ICON,
                                width: '20px',
                            }}
                            tag={IconOrderTime}
                            className="mr-4 d-block"
                        />
                        {getRealTime(createdDate)}
                    </div>
                    <div className="col-12 mt-4 col-md-6 d-flex y-top">
                        <DynamicColor
                            style={{
                                fill: COLOR_NAME.BODY_ICON,
                                width: '24px',
                            }}
                            tag={IconDeliverTime}
                            className="mr-4 d-block"
                        />
                        {timeDeliver
                            ? getRealTime(timeDeliver)
                            : t('orderHistory.lbWaitingConfirm')}
                    </div>
                </div>

                <div className="mt-4 d-flex y-top">
                    <DynamicColor
                        style={{
                            fill: COLOR_NAME.BODY_ICON,
                            width: '20px',
                        }}
                        tag={IconHomeFill}
                        className="mr-4 d-block"
                    />
                    {[`${userAddressNumber} ${userStreet}`, userCity]
                        .filter(Boolean)
                        .join(', ')}
                </div>
            </DynamicColor>

            <div className="d-flex y-center heading-6 m-2">
                <DynamicColor
                    style={{
                        color: COLOR_NAME.BODY_ICON,
                        width: '24px',
                    }}
                    tag={ICON_PAYMENT[paymentMethod]}
                />

                <FormatCurrency
                    tag="div"
                    className="ml-4 label-1"
                    amount={totalMoney}
                />
            </div>
        </DynamicColor>
    )
}

export default OrderHisItem
